import { render, staticRenderFns } from "./AvatarMenu.vue?vue&type=template&id=4635dbcf"
import script from "./AvatarMenu.vue?vue&type=script&lang=ts"
export * from "./AvatarMenu.vue?vue&type=script&lang=ts"
import style0 from "./AvatarMenu.vue?vue&type=style&index=0&id=4635dbcf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsIdentidadIcon: require('/opt/atlassian/pipelines/agent/build/components/icons/IdentidadIcon.vue').default,IconsSubmoduleIcon: require('/opt/atlassian/pipelines/agent/build/components/icons/SubmoduleIcon.vue').default,ExpedienteLevelUpDialog: require('/opt/atlassian/pipelines/agent/build/components/expediente/LevelUpDialog.vue').default})
